import { observable, action } from 'mobx'

class InfoStore {
  @observable message = undefined
  @observable modalIsOpen = false
  @observable changePath = undefined

  constructor() {
    this.displayInfo = this.displayInfo.bind(this)
  }

  @action.bound displayInfo(message) {
    this.message = message
    this.modalIsOpen = this.message !== undefined
  }

  @action.bound close() {
    this.message = undefined
    this.modalIsOpen = false
  }
}

export default new InfoStore()



// WEBPACK FOOTER //
// ./src/stores/infoStore.js